import { useMutation, useQueryClient } from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_COMPANIES } from "../domain";
import { ACTION_GET_CURRENT_COMPANY_INFO } from "../GetCurrentCompanyInfo/useGetCurrentCompanyInfo";

import { companiesApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_COMPANY_LOGO = "UPDATE_COMPANY_LOGO";

const allowedRoles = [UserRole.Owner];

interface UpdateCompanyLogoProps {
  companyId: string;
  fileId: string;
}

const updateCompanyLogo = async (params: UpdateCompanyLogoProps): Promise<void> => {
  const { companyId, fileId } = params;

  await companiesApi.companiesControllerUpdateCompanyLogo(companyId, {
    fileId,
  });
};

export const useUpdateCompanyLogo = (
  user: UserProfileDto | null,
): {
  updateCompanyLogo: (params: UpdateCompanyLogoProps) => void;
  updateCompanyLogoEnabled: boolean;
  isSuccessUpdateCompanyLogo: boolean;
  isPendingUpdateCompanyLogo: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation<
    void,
    Error,
    UpdateCompanyLogoProps
  >({
    mutationKey: [DOMAIN_COMPANIES, ACTION_UPDATE_COMPANY_LOGO],
    mutationFn: enabled ? updateCompanyLogo : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_COMPANIES, ACTION_GET_CURRENT_COMPANY_INFO],
      });
    },
  });

  return {
    updateCompanyLogo: mutate,
    updateCompanyLogoEnabled: enabled,
    isSuccessUpdateCompanyLogo: isSuccess,
    isPendingUpdateCompanyLogo: isPending,
  };
};
